import React, { useState } from "react";
import {
  CalendarIconGray,
  ChatBlackIcon,
  ClockIconGray,
  coachDemoImg,
  LocationIconGray,
  CancelIconBlack,
  FlagIconBlack,
  EditIconGray,
} from "../../../../constant/imagePath";
import Fonts from "../../../../stories/assets/Fonts";
import Colors from "../../../../stories/assets/Colors";
import classes from "./WeeklyAvailbility.module.css";
import { Col, Row } from "react-bootstrap";
import { ReactSVG } from "react-svg";
import PropTypes from "prop-types";
import moment from "moment";
import { Button } from "../../../../stories/Button/Button";
import { LinkButtonWithIcon } from "../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { Checkbox } from "../../../../stories/Checkbox/Checkbox";
import { Radio } from "../../../../stories/Radio/Radio";
import { Input } from "../../../../stories/Input/Input";

function WeeklyAvailability({
  data,
  dates,
  setDates,
  setLocation,
  location,
  repetition,
  setRepetition,
  onSave,
  onCancel,
}) {
  return (
    <div className={classes.card}>
      <div
        className={classes.header}
        style={{ background: Colors.neutralShadesOfWhisper }}
      >
        <h5 style={{ ...Fonts.h5, color: Colors.mainBlue }}>
          Monday, August 23
        </h5>
        <Button icon={EditIconGray} primary={false} size={"Small"} />
      </div>
      <div className={classes.contentContainer}>
        {/* Input Range */}
        <div className={classes.inputBoxes}>
          <Input
            placeholder={"Start date"}
            inputStyle={{ padding: "12px 16px" }}
          />
          <span className={classes.dash}>-</span>
          <Input
            placeholder={"End date"}
            inputStyle={{ padding: "12px 16px" }}
          />
        </div>
        {/* Checkboxes */}
        <div
          className={`${[classes.mt28, classes.optionsContainer].join(" ")}`}
        >
          <p
            style={{ ...Fonts.h9, color: Colors.neutralShadesOfDimGray }}
            className={classes.mb16}
          >
            Location
          </p>
          <Checkbox
            label="Royal Tennis Court"
            value={location}
            setValue={setLocation}
          />
          <Checkbox
            label="Green Tennis Court"
            value={location}
            setValue={setLocation}
          />
        </div>
        {/* Radios */}
        <div
          className={`${[classes.mt28, classes.optionsContainer].join(" ")}`}
        >
          <p
            style={{ ...Fonts.h9, color: Colors.neutralShadesOfDimGray }}
            className={classes.mb16}
          >
            Repetition
          </p>
          <Radio
            label="Repeats weekly"
            value={repetition}
            setValue={setRepetition}
          />
          <Radio
            label="Repeats monthly"
            value={repetition}
            setValue={setRepetition}
          />
          <Radio
            label="Does not repeat"
            value={repetition}
            setValue={setRepetition}
          />
        </div>
      </div>

      <div
        className={classes.footer}
        style={{ borderTop: `1px solid ${Colors.neutralShadesOfWhisper}` }}
      >
        <LinkButtonWithIcon
          customStyle={{ marginRight: "24px" }}
          text={"Cancel"}
          onClick={onCancel}
        />
        <Button
          primary={data?.status == "pending" ? true : false}
          size={"Medium"}
          label={"Save"}
          customStyle={{ padding: "8px 16px", width: "max-content" }}
          onClick={onSave}
        />
      </div>
    </div>
  );
}
WeeklyAvailability.propTypes = {
  data: PropTypes.object,
};
WeeklyAvailability.defaultProps = {
  data: {
    start: moment(moment().add(-3, "hours").format())
      .add(0, "days")
      .format("LT"),
    end: moment(moment().add(3, "hours").format()).add(0, "days").format("LT"),
    type: "1-on-1",
    id: 1,
    title: "Tennis Lesson with Jenny",
    eventDate: moment().add(0, "days").format("MMM DD, YYYY"),
    location: "Green Tennis Court",
    // status: "upcoming",
    status: "pending",
    user: {
      profile: coachDemoImg,
    },
  },
};

export default WeeklyAvailability;
